import { ThemeType } from '../../types/themeTypes';
import { WebViewSyncHandler, WebViewSyncKey } from '../../types/webViewSyncTypes';
import notificationStore from './notificationStore';
import themeStore from './themeStore';

/**
 * 각 웹뷰에서 UI 동기화를 위한 핸들러
 * - 예: 알림 클릭 시 뱃지 제거, 좋아요 동기화 등
 * - 가능하면 액션을 최소화해야 한다
 * - 이 핸들러는 글로벌 핸들러
 *   - 이 핸들러에서 웹뷰 간 공유되는 액션을 싱글턴 스토어로 구분되어 있어야 한다
 *   - 생략 가능한 것은 무시한다 (예: 알림 클릭 표시 - 이건 네비게이션 페이지에서만 보이므로 무시)
 * - 각 컴포넌트에서 처리해야 하는 것은 addSyncUiHandler 로 추가해야 한다
 */
const webViewUiSyncHandlers: {
    [key in WebViewSyncKey]?: WebViewSyncHandler<key>;
} = {
    /**
     * 알림 읽음 처리
     */
    notificationMarkAsRead: async (data: {}) => {
        notificationStore.clearHasUnreadNotifications();
    },
    themeChanged: async (data: { theme: ThemeType }) => {
        themeStore.setTheme(data.theme);
    },
    // like: async (data: { postId: string; isLiked: boolean }) => {
    //     console.log('like', data);
    // },
};

export default webViewUiSyncHandlers;
